module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" Copyright © 2009 by Debra Gwartney")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")]), _c('br'), _vm._v("\nGwartney, Debra.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Live through this: a mother’s memoir of runaway daughters / Debra Gwartney."), _c('br'), _vm._v("\np. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-05447-6")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("1. Runaway teenagers—West (U.S.) 2. Teenage girls—West (U.S.) 3. Mothers and daughters—West (U.S.) I. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("HV")]), _vm._v("1435.W4G93 2008"), _c('br'), _vm._v("\n362.74—dc22"), _c('br'), _vm._v("\n["), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("B")]), _vm._v("] 2008013751")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-547-34788-2"), _c('br'), _vm._v("\nv2.0414")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('em', [_vm._v("Note:")]), _vm._v(" Some names have been changed to protect the privacy of individuals.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Excerpt from “Birches” from "), _c('em', [_vm._v("The Poetry of Robert Frost")]), _vm._v(" edited by Edward Connery Lathem. Copyright 1916, 1969 by Henry Holt and Company. Copyright 1944 by Robert Frost. Reprinted by permission of Henry Holt and Company, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("Portions of this book previously appeared in a somewhat different form: “Far Away, So Close,” in "), _c('em', [_vm._v("Salon,")]), _vm._v(" “Mothers Who Think” column, November 23, 1998; “Tenderloin,” in "), _c('em', [_vm._v("Creative Nonfiction,")]), _vm._v(" no. 16, 1999, pages 21–30; “Tent,” in "), _c('em', [_vm._v("Fourth Genre,")]), _vm._v(" vol. 3, no. 1, Spring 2001, pages 20–27; “Out of Gas,” in "), _c('em', [_vm._v("Tampa Review,")]), _vm._v(" 33/34, 2007, pages 19–27; “Runaway Bus,” in "), _c('em', [_vm._v("Portland Monthly,")]), _vm._v(" January 2006. “Runaway Daughter” was included in the anthology "), _c('em', [_vm._v("I Wanna Be Sedated,")]), _vm._v(" published by Seal Press, March 2005. And a segment related to this book was broadcast on "), _c('em', [_vm._v("This American Life,")]), _vm._v(" Chicago Public Radio, March 29, 2002.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2081d925","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0